import { render, staticRenderFns } from "./GalleryThumbLink.vue?vue&type=template&id=5ae7faf5"
import script from "./GalleryThumbLink.vue?vue&type=script&lang=js"
export * from "./GalleryThumbLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports